import { Stack } from "@mui/material"
import Text from "./Text"
import { colors } from "../../../services/config/colors"
import { CSSProperties, useContext } from "react"
import { MainContext } from "../../../controllers/main"

const Badge = ({
  label,
  icon,
  style,
}: {
  label: string
  icon?: string
  style?: CSSProperties
}) => {
  const { isMobile } = useContext(MainContext)

  return (
    <Stack
      gap={0.5}
      direction="row"
      alignItems="center"
      style={{
        width: "auto",
        height: isMobile ? 32 : 40,
        paddingInline: isMobile ? 8 : 10,
        borderRadius: 4,
        backgroundColor: colors.backgroundWhite,
        border: isMobile
          ? "1px solid " + colors.primary
          : "1.5px solid " + colors.primary,
        ...style,
      }}
    >
      {icon ? <img src={icon} width={26} /> : null}
      <Text
        fontSize={isMobile ? 14 : 18}
        fontWeight={700}
        color={colors.primary}
        style={{ marginTop: isMobile ? 4 : 6 }}
      >
        {label}
      </Text>
    </Stack>
  )
}

export default Badge
